import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BankAccountCards from './BankAccountCards';

const ClientPaymentSlipUpload = ({ bankAccounts = [], uploading, onUpload }) => {
  const { t } = useTranslation();
  const activeAccounts = bankAccounts.filter((a) => a.isActive !== false);
  const [selectedBankId, setSelectedBankId] = useState('');
  const needsPick = activeAccounts.length > 1;

  useEffect(() => {
    if (activeAccounts.length === 1) setSelectedBankId(activeAccounts[0]._id);
  }, [activeAccounts]);

  const canUpload = !needsPick || selectedBankId;

  return (
    <div className="space-y-2">
      {activeAccounts.length > 0 && (
        <BankAccountCards
          accounts={activeAccounts}
          selectable={needsPick}
          selectedId={selectedBankId}
          onSelect={setSelectedBankId}
        />
      )}
      <label
        className={`inline-flex cursor-pointer rounded-lg border border-zinc-300 px-3 py-1.5 text-xs dark:border-zinc-700 hover:bg-zinc-100 dark:hover:bg-zinc-800 ${
          !canUpload || uploading ? 'pointer-events-none opacity-50' : ''
        }`}
      >
        {uploading ? t('toast.uploadingSlip') : t('client.orders.uploadSlip')}
        <input
          type="file"
          accept="image/*"
          className="hidden"
          disabled={!canUpload || uploading}
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onUpload(file, selectedBankId || activeAccounts[0]?._id);
            e.target.value = '';
          }}
        />
      </label>
      {needsPick && !selectedBankId && (
        <p className="text-[10px] text-amber-400">{t('payments.bank.selectBeforeUpload')}</p>
      )}
    </div>
  );
};

export default ClientPaymentSlipUpload;
